import { Link } from 'react-router-dom';
import SectionHeader from '@/components/base/SectionHeader';

const categories = [
  {
    title: '治愈番专区',
    desc: '催泪、清新、暖心的治愈系佳作，温柔抚平每一天。',
    to: '/category/healing',
    icon: 'ri-heart-line',
    image:
      'https://readdy.ai/api/search-image?query=warm%20sunlit%20anime%20illustration%20of%20two%20friends%20relaxing%20on%20a%20flower%20meadow%20under%20a%20clear%20sky%2C%20healing%20peaceful%20emotion%2C%20soft%20golden%20light%2C%20pastel%20warm%20colors%2C%20anime%20background%20art&width=800&height=600&seq=cat-healing&orientation=landscape',
  },
  {
    title: '日常番合集',
    desc: '轻松搞笑、悠然慢节奏的日常番，看着看着就笑了。',
    to: '/category/daily',
    icon: 'ri-plant-line',
    image:
      'https://readdy.ai/api/search-image?query=cozy%20anime%20illustration%20of%20a%20bright%20lived%20in%20living%20room%20with%20friends%20chatting%20over%20snacks%20by%20a%20sunny%20window%2C%20cheerful%20slice%20of%20life%20daily%20mood%2C%20warm%20colors%2C%20anime%20background%20art&width=800&height=600&seq=cat-daily&orientation=landscape',
  },
  {
    title: '萌系动画',
    desc: '软萌治愈的萌系小剧场，短小上头的可爱日常。',
    to: '/category/daily',
    icon: 'ri-cup-fill',
    image:
      'https://readdy.ai/api/search-image?query=adorable%20anime%20illustration%20of%20cute%20tiny%20round%20creatures%20and%20a%20small%20cat%20playing%20together%20on%20a%20soft%20blanket%2C%20kawaii%20moe%20style%2C%20warm%20soft%20pastel%20colors%2C%20anime%20art%20style&width=800&height=600&seq=cat-moe&orientation=landscape',
  },
];

export default function CategoryNav() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionHeader
        eyebrow="按分类直达"
        title="想找哪类番，点进去更省事"
        description="牛奶动漫库按治愈、日常、萌系三大方向整理补番目录，专为不同心情准备的挑选入口。"
      />
      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {categories.map((cat) => (
          <Link
            key={cat.title}
            to={cat.to}
            className="group relative overflow-hidden rounded-2xl bg-background-100"
          >
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src={cat.image}
                alt={`${cat.title} 补番目录分类插画`}
                title={`${cat.title} 牛奶动漫库`}
                className="h-full w-full object-cover object-center transition duration-500 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-5">
              <div className="mb-2 flex items-center gap-2 text-background-50">
                <i className={`${cat.icon} text-lg text-accent-300`}></i>
                <h3 className="font-heading text-xl font-bold">{cat.title}</h3>
              </div>
              <p className="text-sm leading-relaxed text-background-100">{cat.desc}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}